import { render, staticRenderFns } from "./RziMonitoringItemSection.vue?vue&type=template&id=483eadff&scoped=true&"
import script from "./RziMonitoringItemSection.vue?vue&type=script&lang=js&"
export * from "./RziMonitoringItemSection.vue?vue&type=script&lang=js&"
import style0 from "./RziMonitoringItemSection.vue?vue&type=style&index=0&id=483eadff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483eadff",
  null
  
)

export default component.exports